var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "position-relative" }, [
    _vm.isLoggedIn
      ? _c("div", { staticClass: "dropdown" }, [
          _c(
            "a",
            {
              staticClass: "dropdown-toggle nav-link",
              attrs: {
                href: "#",
                id: "accountMenuList",
                "data-toggle": "dropdown",
                "aria-haspopup": "true",
                "aria-expanded": "false",
                "data-boundary": "window",
              },
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    width: "40",
                    height: "40",
                    viewBox: "0 0 40 40",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M19.5747 29.9999C24.8626 29.9999 29.1493 25.7132 29.1493 20.4253C29.1493 15.1373 24.8626 10.8506 19.5747 10.8506C14.2867 10.8506 10 15.1373 10 20.4253C10 25.7132 14.2867 29.9999 19.5747 29.9999Z",
                      stroke: "#F0C42E",
                      "stroke-miterlimit": "10",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      d: "M17.9834 12.6697C18.3184 12.6101 18.6551 12.5713 18.9902 12.5547",
                      stroke: "#F0C42E",
                      "stroke-miterlimit": "10",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      d: "M13.9785 14.6595C14.8779 13.8849 15.9918 13.19 17.1645 12.8589",
                      stroke: "#F0C42E",
                      "stroke-miterlimit": "10",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      d: "M19.5681 21.352C21.1072 21.352 22.3549 20.1043 22.3549 18.5652C22.3549 17.026 21.1072 15.7783 19.5681 15.7783C18.029 15.7783 16.7812 17.026 16.7812 18.5652C16.7812 20.1043 18.029 21.352 19.5681 21.352Z",
                      stroke: "#F0C42E",
                      "stroke-miterlimit": "10",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      d: "M14.792 25.0733C14.792 23.5809 16.013 22.3599 17.5054 22.3599H21.6385C23.1308 22.3599 24.3519 23.5809 24.3519 25.0733",
                      stroke: "#F0C42E",
                      "stroke-miterlimit": "10",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      d: "M20.4223 29.1493C25.7103 29.1493 29.997 24.8626 29.997 19.5747C29.997 14.2867 25.7103 10 20.4223 10C15.1344 10 10.8477 14.2867 10.8477 19.5747C10.8477 24.8626 15.1344 29.1493 20.4223 29.1493Z",
                      stroke: "#0E0F12",
                      "stroke-miterlimit": "10",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      d: "M18.8291 11.8191C19.1641 11.7595 19.5008 11.7208 19.8359 11.7041",
                      stroke: "#0E0F12",
                      "stroke-miterlimit": "10",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      d: "M14.8242 13.8089C15.7236 13.0343 16.8375 12.3395 18.0102 12.0083",
                      stroke: "#0E0F12",
                      "stroke-miterlimit": "10",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      d: "M20.4157 20.5014C21.9549 20.5014 23.2026 19.2537 23.2026 17.7146C23.2026 16.1754 21.9549 14.9277 20.4157 14.9277C18.8766 14.9277 17.6289 16.1754 17.6289 17.7146C17.6289 19.2537 18.8766 20.5014 20.4157 20.5014Z",
                      stroke: "#0E0F12",
                      "stroke-miterlimit": "10",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      d: "M15.6396 24.2227C15.6396 22.7303 16.8607 21.5093 18.3531 21.5093H22.4861C23.9785 21.5093 25.1995 22.7303 25.1995 24.2227",
                      stroke: "#0E0F12",
                      "stroke-miterlimit": "10",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                    },
                  }),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "account-menu dropdown-menu dropdown-menu-right small",
            },
            [
              _c(
                "div",
                {
                  staticClass: "list-group",
                  attrs: { "aria-labelledby": "accountMenuList" },
                },
                [
                  _c("a", { attrs: { href: _vm.$ceres.urls.myAccount } }, [
                    _c("i", { staticClass: "fa fa-user" }),
                    _vm._v(
                      " " +
                        _vm._s(_vm.$translate("Ceres::Template.loginMyAccount"))
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      directives: [{ name: "logout", rawName: "v-logout" }],
                      attrs: { href: "#" },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$translate("Ceres::Template.loginLogout"))
                      ),
                    ]
                  ),
                ]
              ),
            ]
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.isLoggedIn
      ? _c("div", [
          _c(
            "a",
            {
              attrs: {
                href: "#",
                id: "accountMenuList",
                "data-toggle": "dropdown",
                "aria-haspopup": "true",
                "aria-expanded": "false",
                "data-boundary": "window",
              },
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    width: "40",
                    height: "40",
                    viewBox: "0 0 40 40",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M19.5747 29.9999C24.8626 29.9999 29.1493 25.7132 29.1493 20.4253C29.1493 15.1373 24.8626 10.8506 19.5747 10.8506C14.2867 10.8506 10 15.1373 10 20.4253C10 25.7132 14.2867 29.9999 19.5747 29.9999Z",
                      stroke: "#F0C42E",
                      "stroke-miterlimit": "10",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      d: "M17.9834 12.6697C18.3184 12.6101 18.6551 12.5713 18.9902 12.5547",
                      stroke: "#F0C42E",
                      "stroke-miterlimit": "10",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      d: "M13.9785 14.6595C14.8779 13.8849 15.9918 13.19 17.1645 12.8589",
                      stroke: "#F0C42E",
                      "stroke-miterlimit": "10",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      d: "M19.5681 21.352C21.1072 21.352 22.3549 20.1043 22.3549 18.5652C22.3549 17.026 21.1072 15.7783 19.5681 15.7783C18.029 15.7783 16.7812 17.026 16.7812 18.5652C16.7812 20.1043 18.029 21.352 19.5681 21.352Z",
                      stroke: "#F0C42E",
                      "stroke-miterlimit": "10",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      d: "M14.792 25.0733C14.792 23.5809 16.013 22.3599 17.5054 22.3599H21.6385C23.1308 22.3599 24.3519 23.5809 24.3519 25.0733",
                      stroke: "#F0C42E",
                      "stroke-miterlimit": "10",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      d: "M20.4223 29.1493C25.7103 29.1493 29.997 24.8626 29.997 19.5747C29.997 14.2867 25.7103 10 20.4223 10C15.1344 10 10.8477 14.2867 10.8477 19.5747C10.8477 24.8626 15.1344 29.1493 20.4223 29.1493Z",
                      stroke: "#0E0F12",
                      "stroke-miterlimit": "10",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      d: "M18.8291 11.8191C19.1641 11.7595 19.5008 11.7208 19.8359 11.7041",
                      stroke: "#0E0F12",
                      "stroke-miterlimit": "10",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      d: "M14.8242 13.8089C15.7236 13.0343 16.8375 12.3395 18.0102 12.0083",
                      stroke: "#0E0F12",
                      "stroke-miterlimit": "10",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      d: "M20.4157 20.5014C21.9549 20.5014 23.2026 19.2537 23.2026 17.7146C23.2026 16.1754 21.9549 14.9277 20.4157 14.9277C18.8766 14.9277 17.6289 16.1754 17.6289 17.7146C17.6289 19.2537 18.8766 20.5014 20.4157 20.5014Z",
                      stroke: "#0E0F12",
                      "stroke-miterlimit": "10",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      d: "M15.6396 24.2227C15.6396 22.7303 16.8607 21.5093 18.3531 21.5093H22.4861C23.9785 21.5093 25.1995 22.7303 25.1995 24.2227",
                      stroke: "#0E0F12",
                      "stroke-miterlimit": "10",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                    },
                  }),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "account-menu dropdown-menu dropdown-menu-right small",
            },
            [
              _c(
                "div",
                {
                  staticClass: "list-group",
                  attrs: { "aria-labelledby": "accountMenuList" },
                },
                [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: _vm.isLogin ? "javascript:void(0)" : "#login",
                        "data-toggle": _vm.isLogin ? false : "modal",
                        "aria-label": _vm.$translate("Ceres::Template.login"),
                      },
                      on: {
                        click: function ($event) {
                          _vm.createLoginModal()
                          _vm.unmarkInputFields()
                        },
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-user",
                        attrs: { "aria-hidden": "true" },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "hidden-xs-down" }, [
                        _vm._v(_vm._s(_vm.$translate("Ceres::Template.login"))),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.showRegistration
                    ? _c(
                        "a",
                        {
                          attrs: {
                            href: _vm.isRegister
                              ? "javascript:void(0)"
                              : "#registration",
                            "data-toggle": _vm.isRegister ? false : "modal",
                            "aria-label": _vm.$translate(
                              "Ceres::Template.loginRegister"
                            ),
                          },
                          on: {
                            click: function ($event) {
                              _vm.createRegisterModal()
                              _vm.unmarkInputFields()
                            },
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-user-plus",
                            attrs: { "aria-hidden": "true" },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "hidden-xs-down" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$translate("Ceres::Template.loginRegister")
                              )
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ]
              ),
            ]
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }